import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import PageBackgroundPanel from '../../../../components/Editor/EditPanel/PageBackgroundPanel';
import { getPageBgData, getGeneralBgData } from '../../selectors';
import { BackgroundMediaData } from '../../reducer';

const getImportManagerId = (page: number): string => {
	const prefix = 'bgMedia';
	return `${prefix}-${page}`;
};

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			slider: { page },
		},
		importManager: { byId },
	} = state;

	const backgroundData = getPageBgData(state) || getGeneralBgData(state);
	let currentBgMediaData: BackgroundMediaData | undefined;
	let defaultBgMediaData: BackgroundMediaData | undefined;

	if (backgroundData && !backgroundData.defaultColor) {
		currentBgMediaData = backgroundData.currentMedia;
		defaultBgMediaData = backgroundData.defaultMedia;
	}

	const importManagerId = getImportManagerId(page);

	return {
		page,
		currentBgMediaData,
		isDefaultBgMediaData: !!defaultBgMediaData,
		isGeneralBgData: !getPageBgData(state) && !!getGeneralBgData(state),
		importManagerId,
		isImporting: !!byId[importManagerId],
	};
};

export default connect(mapStateToProps)(PageBackgroundPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/PageBackgroundPanel/index.tsx